/** Arabic for the platform, the map and sign-in: settings, administration, migration, the map, drift, reliability, weather, the ledger, liability, the menu editor, the access gate and the sign-in gate. Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  "Those are the right six digits, but for a different moment: the clock on the device running the app is about {n} seconds behind. Set that device to get the time automatically, then read the next code.":
    "هذه هي الأرقام الستة الصحيحة، لكنها للحظة أخرى: ساعة الجهاز الذي يعمل عليه التطبيق متأخرة بنحو {n} ثانية. اضبط ذلك الجهاز على أخذ الوقت تلقائيًا، ثم اقرأ الرمز التالي.",
  "Those are the right six digits, but for a different moment: the clock on the device running the app is about {n} seconds ahead. Set that device to get the time automatically, then read the next code.":
    "هذه هي الأرقام الستة الصحيحة، لكنها للحظة أخرى: ساعة الجهاز الذي يعمل عليه التطبيق متقدمة بنحو {n} ثانية. اضبط ذلك الجهاز على أخذ الوقت تلقائيًا، ثم اقرأ الرمز التالي.",
  "That is a code from the barcode this one replaces. The app now holds two entries called Sky Logics — delete the older one, and read the code from the entry added just now.":
    "هذا رمز من الرمز الشريطي الذي حلّ هذا محلّه. يحتفظ التطبيق الآن بمدخلين باسم Sky Logics — احذف الأقدم، واقرأ الرمز من المدخل المضاف للتو.",
  "That recovery code is not on the list, or it has already been spent.":
    "رمز الاسترداد هذا ليس في القائمة، أو أنه استُهلك من قبل.",
  "Type the password for this account.": "اكتب كلمة المرور الخاصة بهذا الحساب.",
  "This account has been through a barcode before, so the app will end up holding two entries with the same name. Delete the older one as soon as the code below is accepted — nothing on the phone says which of the two is live, and the old one is refused.":
    "سبق لهذا الحساب أن مرّ برمز شريطي، لذا سينتهي الأمر بالتطبيق وهو يحمل مدخلين بالاسم نفسه. احذف الأقدم بمجرد قبول الرمز أدناه — لا شيء في الهاتف يبيّن أيّهما الفعّال، والقديم مرفوض.",
  "THE APP IS GONE — START THE AUTHENTICATOR AGAIN": "التطبيق مفقود — ابدأ إعداد المصادقة من جديد",
  "Start the authenticator again": "ابدأ إعداد تطبيق المصادقة من جديد",
  "For when the app is gone and the recovery codes with it. Type the password for this account and a new barcode is shown.":
    "لحالة فقدان التطبيق ورموز الاسترداد معه. اكتب كلمة مرور هذا الحساب ليُعرض رمز شريطي جديد.",
  "Said plainly: this asks again for something already accepted one screen ago, so it is as strong as the password and no stronger. It is here because the alternative was an account that could never be signed into again.":
    "بصراحة: هذا يطلب مجددًا شيئًا قُبل قبل شاشة واحدة، فهو بقوة كلمة المرور ولا يزيد. وُضع هنا لأن البديل كان حسابًا لا يمكن الدخول إليه أبدًا مرة أخرى.",
  "SHOW A NEW BARCODE": "إظهار رمز شريطي جديد",
  "Enter the current six-digit code or a recovery code.": "أدخل الرمز الحالي المكوّن من ستة أرقام أو رمز استرداد.",
  "That code is not valid, or the recovery code has already been used.":
    "هذا الرمز غير صالح، أو أن رمز الاسترداد استُخدم من قبل.",
  Authenticator: "تطبيق المصادقة",
  "Show the barcode again": "إظهار الرمز الشريطي مجددًا",
  "For a new phone, or if the app was never set up. Prove it is you with the six digits from the app you have now, or with one of your recovery codes. A new barcode is then shown to scan; the old one stops working once a code from the new one is accepted.":
    "لهاتف جديد، أو إذا لم يُعَدّ التطبيق من قبل. أثبت هويتك بالأرقام الستة من التطبيق الذي لديك الآن، أو بأحد رموز الاسترداد. يُعرض بعدها رمز شريطي جديد لمسحه، ويتوقف الرمز القديم عن العمل بمجرد قبول رمز من الجديد.",
  "Current code or recovery code": "الرمز الحالي أو رمز الاسترداد",
  "SHOW THE BARCODE": "إظهار الرمز الشريطي",
  "SHOW THE BARCODE AGAIN (NEW PHONE)": "إظهار الرمز الشريطي مجددًا (هاتف جديد)",
  "Choose {add}, then {scan}, and point the camera at the code below.":
    "اختر {add}، ثم {scan}، ووجّه الكاميرا نحو الرمز أدناه.",
  "scan a QR code": "مسح رمز QR",
  "No camera? Choose {key} and type the key under the code. Account name: {account}. Type: {type}.":
    "لا تتوفر كاميرا؟ اختر {key} واكتب المفتاح الظاهر تحت الرمز. اسم الحساب: {account}. النوع: {type}.",
  "QR code for your authenticator app": "رمز QR لتطبيق المصادقة",
  // settings
  "Changes are saved as you make them.": "تُحفَظ التغييرات فور إجرائها.",
  Data: "البيانات",
  "built-in sample — nothing here is real": "بيانات تجريبية مضمّنة — لا شيء هنا حقيقي",
  "the platform": "المنصة",
  Tenant: "الجهة",
  Sites: "المواقع",
  "Signed in as": "مسجَّل الدخول باسم",
  "Daylight is a second palette, not an inversion: every state color keeps its meaning, and the drawings drop their night raster. The Daylight and Dark buttons in the header are the same setting.":
    "المظهر النهاري لوحة ألوان ثانية وليس قلبًا للألوان: يحتفظ كل لون حالة بمعناه، وتتخلّى المخططات عن صورتها الليلية. زرّا النهاري والداكن في الترويسة هما الإعداد نفسه.",
  "Reorder, rename or create suites, move screens between them, rename or hide screens. A screen this build adds later joins its usual suite. Which suites are folded open is remembered separately, in this browser.":
    "أعد ترتيب المجموعات أو تسميتها أو أنشئ مجموعات جديدة، وانقل الشاشات بينها، وأعد تسمية الشاشات أو أخفها. الشاشة التي يضيفها هذا الإصدار لاحقًا تنضم إلى مجموعتها المعتادة. أمّا المجموعات المفتوحة فتُحفَظ على حدة في هذا المتصفح.",
  "Customize the menu": "تخصيص القائمة",
  "Back to the default menu": "العودة إلى القائمة الافتراضية",
  "Allowed. Sky can listen — turn on hands-free or her name below, or press the microphone in her panel.":
    "مسموح. تستطيع سكاي الاستماع — فعّل وضع عدم استخدام اليدين أو النداء باسمها أدناه، أو اضغط الميكروفون في لوحتها.",
  "Refused. This page is shown inside another page, and that host does not pass the microphone through. Open the platform directly — at its own address, over HTTPS — and allow it there.":
    "مرفوض. تُعرَض هذه الصفحة داخل صفحة أخرى، والصفحة المضيفة لا تمرّر الميكروفون. افتح المنصة مباشرة — على عنوانها الخاص وعبر HTTPS — واسمح به هناك.",
  "Refused. Click the lock or the tuning icon at the left of the address bar, find Microphone, set it to Allow, then reload.":
    "مرفوض. انقر رمز القفل أو رمز الضبط على يسار شريط العنوان، وابحث عن الميكروفون، واضبطه على السماح، ثم أعد التحميل.",
  "No microphone was found on this machine.": "لم يُعثَر على ميكروفون في هذا الجهاز.",
  "The browser only opens a microphone on a secure page — HTTPS, or localhost. This page is not one.":
    "لا يفتح المتصفح الميكروفون إلا في صفحة آمنة — عبر HTTPS أو على localhost. وهذه الصفحة ليست كذلك.",
  "Could not open the microphone: {reason}": "تعذّر فتح الميكروفون: {reason}",
  "Heard: “{text}”": "سُمِع: «{text}»",
  "Nothing was heard.": "لم يُسمَع شيء.",
  "no speech recognition": "لا يوجد تعرّف على الكلام",
  allowed: "مسموح",
  refused: "مرفوض",
  "not yet asked": "لم يُطلَب بعد",
  "unknown until asked": "غير معروف حتى يُطلَب",
  Microphone: "الميكروفون",
  "Speech recognition": "التعرّف على الكلام",
  "available in this browser": "متاح في هذا المتصفح",
  "not in this browser — Chrome, Edge and Safari have it; Firefox does not":
    "غير متاح في هذا المتصفح — يتوفر في Chrome وEdge وSafari، ولا يتوفر في Firefox",
  Voices: "الأصوات",
  "checking…": "جارٍ التحقق…",
  "{n} installed on this machine": "{n} مثبّتة على هذا الجهاز",
  "none installed — they come from the operating system": "لا يوجد صوت مثبّت — تأتي الأصوات من نظام التشغيل",
  "no speech synthesis in this browser": "لا يوجد توليد للكلام في هذا المتصفح",
  "This page": "هذه الصفحة",
  "shown inside another page — the host decides whether the microphone is passed through, and a review page usually does not":
    "معروضة داخل صفحة أخرى — تقرّر الصفحة المضيفة تمرير الميكروفون من عدمه، وصفحة المراجعة لا تمرّره عادةً",
  "opened directly, on a secure address": "مفتوحة مباشرة، على عنوان آمن",
  "not a secure address — browsers only open a microphone over HTTPS or on localhost":
    "ليست على عنوان آمن — لا تفتح المتصفحات الميكروفون إلا عبر HTTPS أو على localhost",
  "Allow the microphone": "السماح بالميكروفون",
  "Listening…": "جارٍ الاستماع…",
  "Test listening": "اختبار الاستماع",
  "Hear her voice": "استمع إلى صوتها",
  "Say something…": "قل شيئًا…",
  "The browser, not the platform, holds this permission. Allowing it here asks the browser once for this address; what it decides is remembered by the browser and can be changed from the icon at the left of the address bar. In Chrome the audio is sent to Google to be transcribed, which is worth knowing before opening a microphone in an ops room.":
    "المتصفح، لا المنصة، هو من يملك هذا الإذن. السماح به هنا يطلبه من المتصفح مرة واحدة لهذا العنوان، ويحتفظ المتصفح بقراره ويمكن تغييره من الرمز على يسار شريط العنوان. في Chrome يُرسَل الصوت إلى Google لتحويله إلى نص، وهذا ما يجدر معرفته قبل فتح ميكروفون في غرفة العمليات.",
  Now: "الآن",
  "the built-in sample": "البيانات التجريبية المضمّنة",
  " — the platform could not be reached: {reason}": " — تعذّر الوصول إلى المنصة: {reason}",
  "Platform address": "عنوان المنصة",
  "none set": "غير مضبوط",
  "Default site": "الموقع الافتراضي",
  Overridden: "مُستبدَل",
  "yes — this browser's settings are on top of the build's": "نعم — إعدادات هذا المتصفح تعلو إعدادات الإصدار",
  "As built ({source})": "كما في الإصدار ({source})",
  "Automatic — the platform when an address is set, else the sample":
    "تلقائي — المنصة عند ضبط عنوان، وإلا فالبيانات التجريبية",
  "The platform only": "المنصة فقط",
  "The built-in sample only": "البيانات التجريبية المضمّنة فقط",
  "https://platform.example/  or  /  when served by the platform":
    "https://platform.example/  أو  /  عندما تقدّمها المنصة",
  "as built": "كما في الإصدار",
  "issued by the platform": "تُصدره المنصة",
  "Development headers": "ترويسات التطوير",
  "only for a platform started with SLT_DEV_AUTH=1": "فقط لمنصة شُغّلت مع SLT_DEV_AUTH=1",
  "Apply and reload": "تطبيق وإعادة التحميل",
  "Back to the build's settings": "العودة إلى إعدادات الإصدار",
  "Kept in this browser only, and in plain sight of anyone who can open its storage — so this is for a development or review copy, not for a credential that matters. A copy served by the platform itself needs nothing here.":
    "يُحفَظ في هذا المتصفح فقط، ويراه كل من يستطيع فتح مخزنه — لذا فهو لنسخة تطوير أو مراجعة، لا لبيانات اعتماد مهمة. النسخة التي تقدّمها المنصة نفسها لا تحتاج إلى شيء هنا.",
  "Sky · her look and her greeting": "سكاي · مظهرها وتحيّتها",
  "yours alone — stored against your sign-in in this browser": "لك وحدك — محفوظ مع تسجيل دخولك في هذا المتصفح",
  "Sky · voice and listening": "سكاي · الصوت والاستماع",
  "hands-free, her name, reading aloud, and which voice":
    "دون استخدام اليدين، والنداء باسمها، والقراءة بصوت عالٍ، واختيار الصوت",
  "Sky · access level": "سكاي · مستوى الوصول",
  "what she may read, say and open for you — set here until the platform issues it":
    "ما يجوز لها قراءته وقوله وفتحه لك — يُضبط هنا حتى تُصدره المنصة",
  "Sky · what she has learned": "سكاي · ما تعلّمته",
  "every question, which layer answered it, and the screens you taught her":
    "كل سؤال، والطبقة التي أجابت عنه، والشاشات التي علّمتها إياها",
  "Sky · beyond the platform": "سكاي · ما وراء المنصة",
  "a language model and a web search, if you connect them": "نموذج لغوي وبحث على الويب، إن وصلتهما",
  About: "حول",
  "this copy of the platform": "هذه النسخة من المنصة",
  Menu: "القائمة",
  "kept on the platform, under your sign-in": "محفوظ على المنصة، مع تسجيل دخولك",
  "Microphone and speech": "الميكروفون والكلام",
  "what Sky needs to hear you and to speak": "ما تحتاجه سكاي لتسمعك وتتكلم",
  Connection: "الاتصال",
  "which platform this copy talks to — applies on the next load":
    "المنصة التي تتصل بها هذه النسخة — يُطبَّق عند التحميل التالي",
  "API key": "مفتاح API",
  "Default site code": "رمز الموقع الافتراضي",
  Principal: "هوية المستخدم",

  // the sign-in gate
  "That does not look like an email address.": "لا يبدو هذا عنوان بريد إلكتروني.",
  "Use twelve characters or more. Length beats cleverness.": "استخدم اثني عشر حرفًا أو أكثر. الطول أنفع من التعقيد.",
  "The two passwords are not the same.": "كلمتا المرور غير متطابقتين.",
  "Both fields are needed.": "الحقلان كلاهما مطلوبان.",
  "Six digits.": "ستة أرقام.",
  "That code is not valid. Check the clock on the device running the app.":
    "هذا الرمز غير صالح. تحقّق من ساعة الجهاز الذي يعمل عليه التطبيق.",
  "Sign in without a second factor?\n\nOne password is the whole gate then, and it is a gate inside the file it protects.":
    "تسجيل الدخول دون عامل تحقق ثانٍ؟\n\nستكون كلمة مرور واحدة هي البوابة كلها حينئذٍ، وهي بوابة داخل الملف الذي تحميه.",
  "Enter one of the recovery codes.": "أدخل أحد رموز الاسترداد.",
  "That code is not on the list, or it has already been used.": "هذا الرمز ليس في القائمة، أو سبق استخدامه.",
  "Signed in with a recovery code. {n} of the ten are left.\n\nTo set up the authenticator on a phone, sign in again and choose SHOW THE BARCODE AGAIN.":
    "تم تسجيل الدخول برمز استرداد. تبقّى {n} من العشرة.\n\nلإعداد تطبيق المصادقة على هاتف، سجّل الدخول مجددًا واختر «إظهار الرمز الشريطي مجددًا».",
  "Cannot set up the gate here": "تعذّر إعداد بوابة الدخول هنا",
  "This browser will not do the cryptography": "هذا المتصفح لا يُجري عمليات التشفير",
  "Passwords are hashed and the second factor is calculated with Web Crypto, which browsers only provide in a secure context — served over HTTPS, on localhost, or opened as a file in a browser that allows it. This page is on {protocol}, where it is not available.":
    "تُجزَّأ كلمات المرور ويُحسَب عامل التحقق الثاني باستخدام Web Crypto، ولا توفّره المتصفحات إلا في سياق آمن — عبر HTTPS، أو على localhost، أو عند فتح الملف في متصفح يسمح بذلك. هذه الصفحة على {protocol}، حيث لا يتوفر.",
  "Serving the file over HTTPS fixes it, and is the same step that gives the platform real protection. Until then the sign-in screen would be theatre, so it is not offered.":
    "تقديم الملف عبر HTTPS يحلّ المشكلة، وهي الخطوة نفسها التي تمنح المنصة حماية حقيقية. وحتى ذلك الحين ستكون شاشة تسجيل الدخول مجرد استعراض، لذا لا تُعرَض.",
  "CONTINUE WITHOUT SIGNING IN": "المتابعة دون تسجيل الدخول",
  "READ THE SECURITY CHECK": "قراءة الفحص الأمني",
  "Smart Airport Operations Platform — artificial intelligence with a robust predictive model":
    "منصة عمليات المطار الذكية — ذكاء اصطناعي بنموذج تنبؤي متين",
  "Manage your entire airport with the {dashboard}": "أدِر مطارك بالكامل عبر {dashboard}",
  "Sky Logics Smart Dashboard": "لوحة معلومات سكاي لوجيكس الذكية",
  "Predictive reliability": "الموثوقية التنبؤية",
  "failure likelihood, expected counts and 95% intervals from this airport's own records":
    "احتمال الأعطال وأعدادها المتوقعة وفترات ثقة 95% من سجلات هذا المطار نفسه",
  "Intelligent warning systems": "أنظمة الإنذار الذكية",
  "alarms that route themselves, anomalies ranked by consequence, and a warning before a thing fails rather than after":
    "إنذارات توجّه نفسها، وحالات شاذة مرتبة حسب عواقبها، وتحذير قبل أن يتعطل الشيء لا بعده",
  "Safety management": "إدارة السلامة",
  "hazards, risk matrices and the four Annex 19 components": "الأخطار ومصفوفات المخاطر والمكوّنات الأربعة للملحق 19",
  "Smart operational dashboards": "لوحات معلومات تشغيلية ذكية",
  "nineteen boards from the airfield to the money, graded against targets and drawn from the records themselves":
    "تسع عشرة لوحة من الجانب الجوي إلى المال، مقيَّمة مقابل المستهدفات ومستمدة من السجلات نفسها",
  "You are already in": "أنت مسجَّل الدخول بالفعل",
  "Nothing has stopped": "لم يتوقف شيء",
  "This is the cover, shown while the platform keeps running behind it. Development mode is on.":
    "هذه واجهة الغلاف، تُعرَض بينما تستمر المنصة في العمل خلفها. وضع التطوير مفعّل.",
  "This is the cover, shown while your session keeps running behind it.":
    "هذه واجهة الغلاف، تُعرَض بينما تستمر جلستك في العمل خلفها.",
  "BACK TO THE DASHBOARD": "العودة إلى لوحة المعلومات",
  "SIGN OUT INSTEAD": "تسجيل الخروج بدلًا من ذلك",
  "Development mode": "وضع التطوير",
  "Sign-in is switched off": "تسجيل الدخول معطَّل",
  "The credentials and the authenticator code are disabled while these pages are being built. Anyone opening this file walks straight in.":
    "بيانات الاعتماد ورمز المصادقة معطّلة أثناء بناء هذه الصفحات. أي شخص يفتح هذا الملف يدخل مباشرة.",
  "ENTER THE PLATFORM": "الدخول إلى المنصة",
  "Before this goes to anybody": "قبل أن يصل هذا إلى أي أحد",
  "Set {flag} near the top of {file}, rebuild, and the three layers come back exactly as they were — accounts, authenticator and device are all still there, untouched.":
    "اضبط {flag} قرب أعلى {file}، وأعد البناء، فتعود الطبقات الثلاث كما كانت تمامًا — الحسابات والمصادقة والجهاز كلها باقية دون مساس.",
  "First run": "التشغيل الأول",
  "Set up the first account": "إعداد الحساب الأول",
  "No account exists on this device yet. The first one is the administrator.":
    "لا يوجد حساب على هذا الجهاز بعد. الحساب الأول هو المسؤول عن النظام.",
  "Email address": "عنوان البريد الإلكتروني",
  Password: "كلمة المرور",
  "twelve characters or more": "اثنا عشر حرفًا أو أكثر",
  Again: "مرة أخرى",
  "Your role": "دورك",
  "Aerodrome manager": "مدير المطار",
  "CREATE THE ACCOUNT": "إنشاء الحساب",
  "Sign in": "تسجيل الدخول",
  "Restricted system": "نظام مقيَّد",
  "For the people named on the operator's access list. Everything you do is recorded against your account.":
    "للأشخاص المدرجين في قائمة الوصول لدى المشغّل. كل ما تفعله يُسجَّل على حسابك.",
  CONTINUE: "متابعة",
  "1 Credentials": "1 بيانات الاعتماد",
  "2 Authenticator": "2 المصادقة",
  "3 Device": "3 الجهاز",
  "Second factor · where the code comes from": "عامل التحقق الثاني · من أين يأتي الرمز",
  "Set up your authenticator": "إعداد تطبيق المصادقة",
  "The six digit code is generated on your phone, not sent by this system. There is no server here to send anything.":
    "يُولَّد الرمز المكوّن من ستة أرقام على هاتفك، ولا يرسله هذا النظام. لا يوجد خادم هنا ليرسل أي شيء.",
  "Install {app1}, {app2}, {app3} or {app4} on your phone, if you do not have one.":
    "ثبّت {app1} أو {app2} أو {app3} أو {app4} على هاتفك، إن لم يكن لديك واحد منها.",
  "add account": "إضافة حساب",
  "enter a setup key": "إدخال مفتاح الإعداد",
  "time based": "مستند إلى الوقت",
  "The app then shows a six digit code that changes every thirty seconds. Type the current one here.":
    "يعرض التطبيق بعدها رمزًا من ستة أرقام يتغير كل ثلاثين ثانية. اكتب الرمز الحالي هنا.",
  "The key is on the clipboard. Paste it into the app as a setup key.":
    "المفتاح في الحافظة. الصقه في التطبيق بوصفه مفتاح إعداد.",
  "Select the key above and copy it.": "حدّد المفتاح أعلاه وانسخه.",
  "COPY THE KEY": "نسخ المفتاح",
  "Link copied. Open it on the phone that has the authenticator app.":
    "نُسخ الرابط. افتحه على الهاتف المثبّت عليه تطبيق المصادقة.",
  "Copy the key instead.": "انسخ المفتاح بدلًا من ذلك.",
  "COPY THE LINK": "نسخ الرابط",
  "Write these down before you continue": "دوّن هذه الرموز قبل المتابعة",
  "Ten recovery codes. Each works once, instead of a code from the app, if you lose the phone. They are hashed here and cannot be shown again.":
    "عشرة رموز استرداد. يصلح كل منها مرة واحدة بدلًا من رمز التطبيق إذا فقدت الهاتف. تُجزَّأ هنا ولا يمكن عرضها مرة أخرى.",
  "All ten copied. Put them somewhere that is not this device.":
    "نُسخت الرموز العشرة كلها. احفظها في مكان غير هذا الجهاز.",
  "Write them down from the list above.": "دوّنها من القائمة أعلاه.",
  "COPY ALL TEN": "نسخ الرموز العشرة",
  "The six digits from the app": "الأرقام الستة من التطبيق",
  "VERIFY AND CONTINUE": "تحقّق وتابع",
  "SKIP THE SECOND FACTOR": "تخطّي عامل التحقق الثاني",
  Recovery: "الاسترداد",
  "Use a recovery code": "استخدام رمز استرداد",
  "One of the ten codes written down when the account was set up. Each works once, and is then spent.":
    "أحد الرموز العشرة التي دُوّنت عند إعداد الحساب. يصلح كل منها مرة واحدة ثم يُستنفَد.",
  "Recovery code": "رمز الاسترداد",
  "SIGN IN": "تسجيل الدخول",
  "BACK TO THE CODE": "العودة إلى الرمز",
  "Second factor": "عامل التحقق الثاني",
  "Enter the code": "أدخل الرمز",
  "The six digits from your authenticator app for {email}.": "الأرقام الستة من تطبيق المصادقة الخاص بالحساب {email}.",
  "Open your authenticator app and read the code for {issuer}. It changes every thirty seconds.":
    "افتح تطبيق المصادقة واقرأ الرمز الخاص بـ {issuer}. يتغير كل ثلاثين ثانية.",
  Code: "الرمز",
  "USE A RECOVERY CODE": "استخدام رمز استرداد",
  "START AGAIN": "البدء من جديد",
  "Security check": "الفحص الأمني",
  "READ THE FULL CHECK": "قراءة الفحص كاملًا",

  // accounts and the lock-out
  "This browser will not store the account. The gate cannot be set up here.":
    "لن يحفظ هذا المتصفح الحساب. لا يمكن إعداد بوابة الدخول هنا.",
  "No account with that address.": "لا يوجد حساب بهذا العنوان.",
  "Locked for {n} more seconds.": "الحساب مقفل لمدة {n} ثانية أخرى.",
  "Too many attempts. Locked for {n} seconds.": "محاولات كثيرة جدًا. الحساب مقفل لمدة {n} ثانية.",
  "That password is not right. {n} attempt(s) left.": "كلمة المرور غير صحيحة. المحاولات المتبقية: {n}.",

  // the security panel
  "sign-in disabled — anyone can enter": "تسجيل الدخول معطَّل — يستطيع أي أحد الدخول",
  "DEV_OPEN is true, so the credentials and the authenticator are switched off while the pages are built. Set it to false and rebuild before this reaches anybody.":
    "قيمة DEV_OPEN هي true، لذا فبيانات الاعتماد والمصادقة معطّلة أثناء بناء الصفحات. اضبطها على false وأعد البناء قبل أن يصل هذا إلى أي أحد.",
  "Sign-in gate": "بوابة تسجيل الدخول",
  "{n} account(s) held on this device": "عدد الحسابات المحفوظة على هذا الجهاز: {n}",
  "no account set up": "لم يُعَدّ أي حساب",
  "The gate runs inside the file it protects. It stops someone using the screen; it does not stop anyone reading the file.":
    "تعمل البوابة داخل الملف الذي تحميه. تمنع أحدًا من استخدام الشاشة، لكنها لا تمنع أحدًا من قراءة الملف.",
  "Password storage": "تخزين كلمات المرور",
  "PBKDF2-SHA256, 150,000 iterations, per-account salt": "PBKDF2-SHA256، و150,000 تكرار، وملح خاص بكل حساب",
  "unavailable — this browser has no Web Crypto": "غير متاح — لا يدعم هذا المتصفح Web Crypto",
  "Real hashing, so a stolen account file does not hand over the password. It does not protect the data, which is not encrypted.":
    "تجزئة حقيقية، فملف الحسابات المسروق لا يكشف كلمة المرور. لكنها لا تحمي البيانات، فهي غير مشفّرة.",
  "RFC 6238 TOTP, works with any authenticator app": "RFC 6238 TOTP، يعمل مع أي تطبيق مصادقة",
  "not enrolled": "غير مسجَّل",
  "Genuine time-based codes, verified offline against the enrolled secret.":
    "رموز حقيقية مستندة إلى الوقت، يُتحقَّق منها دون اتصال مقابل السر المسجَّل.",
  "How the file is being served": "طريقة تقديم الملف",
  "opened directly from disk (file://)": "مفتوح مباشرة من القرص (file://)",
  "A file on disk can be copied, mailed or opened by anyone with the machine.":
    "الملف على القرص يمكن نسخه أو إرساله بالبريد أو فتحه من قِبل أي شخص يصل إلى الجهاز.",
  "Transport is encrypted. The contents of the file still are not.": "النقل مشفّر. أما محتوى الملف فما زال غير مشفّر.",
  "Not served over HTTPS — anything sent to a connected model or mail service is exposed.":
    "غير مقدَّم عبر HTTPS — كل ما يُرسَل إلى نموذج متصل أو خدمة بريد مكشوف.",
  "Data at rest": "البيانات المخزّنة",
  "embedded in the page, unencrypted": "مضمّنة في الصفحة، غير مشفّرة",
  "The aerodrome drawing, floor plan, friction survey and every register are inside this file. Anyone holding it holds all of it, signed in or not.":
    "مخطط المطار والمخطط الطابقي ومسح الاحتكاك وكل السجلات موجودة داخل هذا الملف. من يحوزه يحوزها كلها، سواء سجّل الدخول أم لا.",
  "Source visibility": "وضوح الشيفرة المصدرية",
  "readable — view source shows every line": "مقروءة — عرض المصدر يُظهر كل سطر",
  "Including this check. Client-side security is a courtesy, not a control.":
    "بما في ذلك هذا الفحص. الأمان من جهة المتصفح مجاملة وليس ضابطًا.",
  Session: "الجلسة",
  "{email} · idles out after {n} minutes": "{email} · تنتهي بعد {n} دقيقة من الخمول",
  "not signed in": "غير مسجَّل الدخول",
  "Held in session storage, so closing the tab ends it.": "محفوظة في تخزين الجلسة، لذا يُنهيها إغلاق علامة التبويب.",
  "Brute force": "التخمين المتكرر",
  "{tries} attempts, then {n} seconds locked": "{tries} محاولات، ثم قفل لمدة {n} ثانية",
  "Slows guessing at the screen. Anyone editing the file bypasses it entirely.":
    "يُبطئ التخمين على الشاشة. أي شخص يعدّل الملف يتجاوزه كليًا.",
  "Audit trail": "سجل التدقيق",
  "{n} entry(s) this session": "عدد القيود في هذه الجلسة: {n}",
  "Held in memory and lost on reload. It is a working record, not an auditable log.":
    "محفوظ في الذاكرة ويضيع عند إعادة التحميل. إنه سجل عمل، لا سجل قابل للتدقيق.",
  "Server-side enforcement": "الإنفاذ من جهة الخادم",
  "none — there is no server": "لا يوجد — لا يوجد خادم",
  "This is the single fix that changes everything: serve the app, keep the data behind an API, and let accounts decide what each person can see.":
    "هذا هو الإصلاح الوحيد الذي يغيّر كل شيء: قدّم التطبيق من خادم، وأبقِ البيانات خلف واجهة API، ودع الحسابات تقرّر ما يمكن لكل شخص رؤيته.",

  // the board provenance line
  "PART SAMPLE": "بيانات تجريبية جزئيًا",
  "{wo} work orders, {ins} inspections and {docs} documents on this board are from the platform — {n} of the work orders have no position recorded and are listed but not drawn. The survey, friction, rubber, the facilities register, projects, assessments and the live feeds are built-in sample data and nothing in them is real.":
    "على هذه اللوحة {wo} أمر عمل و{ins} فحص و{docs} مستند من المنصة — {n} من أوامر العمل بلا موقع مسجَّل، فهي مدرجة في القائمة دون رسمها. أما المسح والاحتكاك والمطاط وسجل المرافق والمشاريع والتقييمات والتغذيات المباشرة فهي بيانات تجريبية مضمّنة ولا شيء فيها حقيقي.",
  "{wo} work orders, {ins} inspections and {docs} documents on this board are from the platform. The survey, friction, rubber, the facilities register, projects, assessments and the live feeds are built-in sample data and nothing in them is real.":
    "على هذه اللوحة {wo} أمر عمل و{ins} فحص و{docs} مستند من المنصة. أما المسح والاحتكاك والمطاط وسجل المرافق والمشاريع والتقييمات والتغذيات المباشرة فهي بيانات تجريبية مضمّنة ولا شيء فيها حقيقي.",

  // the access gate
  "{site} · Access": "{site} · الوصول",
  "Above your access level": "أعلى من مستوى وصولك",
  "This screen needs {level} access": "تتطلب هذه الشاشة مستوى الوصول: {level}",
  "your access on this copy is {level}": "مستوى وصولك في هذه النسخة: {level}",
  "Nothing on it is shown, and Sky will not read or repeat what it holds. Your level covers {what}. Access levels are set by the platform with the sign-in; on this copy the level is set in":
    "لا يُعرَض شيء منها، ولن تقرأ سكاي ما تحتويه أو تكرّره. يشمل مستواك {what}. تضبط المنصة مستويات الوصول مع تسجيل الدخول؛ وفي هذه النسخة يُضبط المستوى في",

  // the menu editor
  "Order the suites and their screens, move screens between suites, rename anything, add your own suites.":
    "رتّب المجموعات وشاشاتها، وانقل الشاشات بين المجموعات، وأعد تسمية ما تشاء، وأضف مجموعاتك الخاصة.",
  "Saved to your account on the platform — the same on every device you sign in on.":
    "يُحفَظ في حسابك على المنصة — ويظهر نفسه على كل جهاز تسجّل الدخول منه.",
  "The platform is not keeping settings for this sign-in, so this is saved in this browser only.":
    "لا تحفظ المنصة الإعدادات لتسجيل الدخول هذا، لذا يُحفَظ هذا في هذا المتصفح فقط.",
  "+ New suite": "+ مجموعة جديدة",
  "Reset to default": "استعادة الافتراضي",
  "Suite {name}": "المجموعة {name}",
  untitled: "بلا عنوان",
  "Suite name": "اسم المجموعة",
  "Move {name} up": "نقل {name} إلى الأعلى",
  "Move suite up": "نقل المجموعة إلى الأعلى",
  "Move {name} down": "نقل {name} إلى الأسفل",
  "Move suite down": "نقل المجموعة إلى الأسفل",
  "Delete — screens go to {name}": "حذف — تنتقل الشاشات إلى {name}",
  "the next suite": "المجموعة التالية",
  Keep: "إبقاء",
  "The menu needs at least one suite": "تحتاج القائمة إلى مجموعة واحدة على الأقل",
  "Delete this suite": "حذف هذه المجموعة",
  "Empty — drag a screen here, or use “Move to” on any screen.":
    "فارغة — اسحب شاشة إلى هنا، أو استخدم «نقل إلى» على أي شاشة.",
  "Drag to move": "اسحب للنقل",
  "Name for {screen}": "اسم {screen}",
  "Originally “{screen}”": "الاسم الأصلي «{screen}»",
  "Rename this screen": "إعادة تسمية هذه الشاشة",
  "Back to “{screen}”": "العودة إلى «{screen}»",
  "undo name": "تراجع عن الاسم",
  "Hidden from the menu; still opens from a link": "مخفية من القائمة؛ وما زالت تُفتح من رابط",
  "Shown in the menu": "ظاهرة في القائمة",
  "Move {screen} to suite": "نقل {screen} إلى مجموعة",
  "In: {name}": "في: {name}",
  "Move to: {name}": "نقل إلى: {name}",
  "Not saved: {error}": "لم يُحفَظ: {error}",
  "Hidden screens: {n}": "الشاشات المخفية: {n}",
  "Saving…": "جارٍ الحفظ…",
  "Save menu": "حفظ القائمة",
  "No changes": "لا تغييرات",
  "{n} screen|{n} screens": "لا شاشات|شاشة واحدة|شاشتان|{n} شاشات|{n} شاشة|{n} شاشة",

  // administration
  "{site} · platform": "{site} · المنصة",
  "Who is here, what they may do, how they get in, and what this deployment still needs. A person’s {level} decides which screens they are offered and what Sky will discuss with them; it never grants a permission. Every endpoint checks its own key, so a level set too high shows a screen whose data the platform then refuses.":
    "من هنا، وما يجوز لهم فعله، وكيف يدخلون، وما يحتاجه هذا النشر بعد. يحدّد {level} الخاص بالشخص الشاشات التي تُعرَض عليه وما تناقشه سكاي معه؛ ولا يمنح أي صلاحية أبدًا. كل نقطة وصول تتحقق من مفتاحها الخاص، لذا فالمستوى المضبوط أعلى مما ينبغي يُظهر شاشة ترفض المنصة بعدها تقديم بياناتها.",
  Setup: "الإعداد",
  People: "الأشخاص",
  "Roles & access": "الأدوار والوصول",
  "Sign-in": "تسجيل الدخول",
  "What this deployment still needs": "ما يحتاجه هذا النشر بعد",
  "{n} blocking step.|{n} blocking steps.":
    "لا خطوات مانعة.|خطوة مانعة واحدة.|خطوتان مانعتان.|{n} خطوات مانعة.|{n} خطوة مانعة.|{n} خطوة مانعة.",
  "Blocking means unsafe or unusable, not merely unfinished. This deployment should not carry anything real until these are done.":
    "المانعة تعني غير آمنة أو غير قابلة للاستخدام، لا مجرد غير مكتملة. لا ينبغي أن يحمل هذا النشر أي شيء حقيقي قبل إنجازها.",
  "{done} of {total} steps done, and {n} of them is blocking — the platform is not ready to carry anything real.":
    "أُنجزت {done} من {total} خطوة، و{n} منها مانعة — المنصة غير جاهزة لحمل أي شيء حقيقي.",
  "{done} of {total} steps done, and {n} of them are blocking — the platform is not ready to carry anything real.":
    "أُنجزت {done} من {total} خطوة، و{n} منها مانعة — المنصة غير جاهزة لحمل أي شيء حقيقي.",
  "All {total} steps done.": "أُنجزت الخطوات كلها ({total}).",
  "{done} of {total} steps done. Nothing blocking; the rest is honest progress.":
    "أُنجزت {done} من {total} خطوة. لا شيء مانع؛ والباقي تقدّم فعلي.",
  "{n} active person holds no role at all. They can sign in and will see an empty platform, which reads as a broken one.|{n} active people hold no role at all. They can sign in and will see an empty platform, which reads as a broken one.":
    "لا يوجد شخص نشط بلا دور.|شخص نشط واحد لا يحمل أي دور. يستطيع تسجيل الدخول وسيرى منصة فارغة تبدو معطّلة.|شخصان نشطان لا يحملان أي دور. يستطيعان تسجيل الدخول وسيريان منصة فارغة تبدو معطّلة.|{n} أشخاص نشطين لا يحملون أي دور. يستطيعون تسجيل الدخول وسيرون منصة فارغة تبدو معطّلة.|{n} شخصًا نشطًا لا يحملون أي دور. يستطيعون تسجيل الدخول وسيرون منصة فارغة تبدو معطّلة.|{n} شخص نشط لا يحملون أي دور. يستطيعون تسجيل الدخول وسيرون منصة فارغة تبدو معطّلة.",
  "Nobody holds a role that can administer this platform. Nobody can grant a role, including to themselves.":
    "لا أحد يحمل دورًا يخوّله إدارة هذه المنصة. لا يستطيع أحد منح دور، ولا حتى لنفسه.",
  "One person can administer this platform. That is one illness away from nobody being able to grant a role.":
    "شخص واحد فقط يستطيع إدارة هذه المنصة. يكفي أن يمرض ليصبح منح أي دور مستحيلًا.",
  "{n} person has no identity-provider subject, so the provider has nothing to bind them to and they can never sign in through it.|{n} people have no identity-provider subject, so the provider has nothing to bind them to and they can never sign in through it.":
    "لا يوجد شخص بلا معرّف لدى مزوّد الهوية.|شخص واحد ليس له معرّف لدى مزوّد الهوية، فلا يجد المزوّد ما يربطه به ولن يستطيع تسجيل الدخول عبره أبدًا.|شخصان ليس لهما معرّف لدى مزوّد الهوية، فلا يجد المزوّد ما يربطهما به ولن يستطيعا تسجيل الدخول عبره أبدًا.|{n} أشخاص ليس لهم معرّف لدى مزوّد الهوية، فلا يجد المزوّد ما يربطهم به ولن يستطيعوا تسجيل الدخول عبره أبدًا.|{n} شخصًا ليس لهم معرّف لدى مزوّد الهوية، فلا يجد المزوّد ما يربطهم به ولن يستطيعوا تسجيل الدخول عبره أبدًا.|{n} شخص ليس لهم معرّف لدى مزوّد الهوية، فلا يجد المزوّد ما يربطهم به ولن يستطيعوا تسجيل الدخول عبره أبدًا.",
  "Add somebody": "إضافة شخص",
  "no email is sent — this creates the row their identity provider's subject binds to":
    "لا يُرسَل بريد إلكتروني — هذا ينشئ السجل الذي يرتبط به معرّفه لدى مزوّد الهوية",
  "{name} added at {level} with {roles}. {note}": "أُضيف {name} بمستوى {level} مع {roles}. {note}",
  "{name} added at {level} with no role yet. {note}": "أُضيف {name} بمستوى {level} دون دور بعد. {note}",
  " Refused: {refused}.": " مرفوض: {refused}.",
  "sign-in subject": "معرّف تسجيل الدخول",
  email: "البريد الإلكتروني",
  "first role": "الدور الأول",
  "no role yet": "لا دور بعد",
  "adding…": "جارٍ الإضافة…",
  "The subject is what the identity provider will send when they sign in. Without one the provider has nothing to bind them to, so the row can never be anybody.":
    "المعرّف هو ما سيرسله مزوّد الهوية عند تسجيل دخولهم. ومن دونه لا يجد المزوّد ما يربطهم به، فلا يمكن أن يمثّل السجل أي شخص.",
  "Worth knowing before you read the list": "ما يجدر معرفته قبل قراءة القائمة",
  "Everybody in this tenant": "كل من في هذه الجهة",
  "{active} active, {disabled} disabled": "{active} نشط، {disabled} معطَّل",
  Person: "الشخص",
  Roles: "الأدوار",
  "Add a role": "إضافة دور",
  "Last seen": "آخر ظهور",
  "Remove {role} from {name}": "إزالة {role} من {name}",
  "Add a role to {name}": "إضافة دور إلى {name}",
  "add…": "إضافة…",
  Enable: "تفعيل",
  Disable: "تعطيل",
  "Disabling refuses the sign-in and keeps the record. Deleting somebody would take their name off every work order they ever signed, which is what a regulator asks to see.":
    "التعطيل يرفض تسجيل الدخول ويُبقي السجل. أما حذف شخص فيزيل اسمه من كل أمر عمل وقّعه يومًا، وهذا ما تطلب الجهة التنظيمية رؤيته.",
  "{role} now offers {level}. This changes what its holders are shown, not what they are permitted.":
    "أصبح {role} يمنح مستوى {level}. هذا يغيّر ما يُعرَض على حامليه، لا ما يُسمح لهم به.",
  "Roles, and what each offers its holders": "الأدوار، وما يمنحه كل منها لحامليه",
  "a level decides what is shown; the permissions decide what is served":
    "المستوى يحدّد ما يُعرَض؛ والصلاحيات تحدّد ما يُقدَّم",
  Role: "الدور",
  Holders: "الحاملون",
  Permissions: "الصلاحيات",
  "Level offered": "المستوى الممنوح",
  Set: "ضبط",
  " · shipped with the platform": " · مرفق مع المنصة",
  " · this tenant's own": " · خاص بهذه الجهة",
  everything: "كل شيء",
  "A built-in is shared by every tenant on this deployment, so changing its level here would change what other tenants' people are shown.":
    "الدور المضمّن مشترك بين كل الجهات المستأجِرة في هذا النشر، لذا فتغيير مستواه هنا سيغيّر ما يُعرَض على أشخاص الجهات الأخرى.",
  "shipped — not editable": "مرفق — غير قابل للتعديل",
  "Level for {name}": "مستوى {name}",
  "A role the platform ships is shared by every tenant on this deployment, so its level cannot be changed from here — create your own role and set that. A person’s level is the highest of the roles they hold.":
    "الدور المرفق مع المنصة مشترك بين كل الجهات المستأجِرة في هذا النشر، لذا لا يمكن تغيير مستواه من هنا — أنشئ دورك الخاص واضبطه. مستوى الشخص هو أعلى مستويات الأدوار التي يحملها.",
  "The development header is enabled": "ترويسة التطوير مفعّلة",
  "Any caller naming a tenant is trusted.": "أي طرف يذكر اسم جهة مستأجِرة يُعَدّ موثوقًا.",
  "Every permission check on this deployment is moot while this is on. Unset {flag} and restart the API before it carries anything real.":
    "كل تحقق من الصلاحيات في هذا النشر بلا جدوى ما دام هذا مفعّلًا. ألغِ ضبط {flag} وأعد تشغيل واجهة API قبل أن تحمل أي شيء حقيقي.",
  "How this deployment authenticates": "كيف يصادق هذا النشر",
  "you are signed in as {principal} by {method}": "أنت مسجَّل الدخول باسم {principal} عبر {method}",
  "No identity provider is configured, so the only way in is an issued API key. Configure the organization’s OIDC provider and people sign in with the account they already have — and leaving the company removes their access here too, which is the part a key cannot do.":
    "لم يُضبط أي مزوّد هوية، لذا فالطريق الوحيد للدخول مفتاح API صادر. اضبط مزوّد OIDC الخاص بالمؤسسة ليسجّل الأشخاص الدخول بالحساب الذي لديهم أصلًا — ومغادرة الشركة تُزيل وصولهم هنا أيضًا، وهذا ما لا يستطيعه المفتاح.",
  Provider: "المزوّد",
  Issuer: "جهة الإصدار",
  Enabled: "مفعّل",
  "Cached keys": "المفاتيح المخزّنة مؤقتًا",
  "Default role": "الدور الافتراضي",
  "What the sign-in gate on this copy is, and is not": "ما هي بوابة تسجيل الدخول في هذه النسخة، وما ليست هي",
  "The gate on this copy — email, password and a six-digit code — stops somebody using this screen. It is not what protects the data. That is the platform’s own authentication above, and the access level it issues with it. A device with its stored accounts cleared enrols again, which is inherent to a gate that lives in a browser.":
    "البوابة في هذه النسخة — البريد الإلكتروني وكلمة المرور ورمز من ستة أرقام — تمنع أحدًا من استخدام هذه الشاشة. وليست هي ما يحمي البيانات؛ بل مصادقة المنصة نفسها أعلاه، ومستوى الوصول الذي تُصدره معها. والجهاز الذي مُسحت حساباته المخزّنة يُسجَّل من جديد، وهذا ملازم لبوابة تعيش في متصفح.",

  // migration
  "Replacing the existing system": "استبدال النظام القائم",
  "{live} of {total} screens live": "{live} من {total} شاشة قيد التشغيل الفعلي",
  "The existing application keeps serving its screens. Each one declared here is mapped onto a public endpoint of this platform, run in shadow beside the real answer, and moved over only when the evidence says it has earned it. A screen that cannot be expressed as a public endpoint is one this platform is not finished for, and shadow running is where that is found out.":
    "يواصل التطبيق القائم تقديم شاشاته. كل شاشة مُعلَنة هنا تُربط بنقطة وصول عامة في هذه المنصة، وتعمل في الظل بجانب الإجابة الحقيقية، ولا تُنقل إلا حين تقول الأدلة إنها استحقت ذلك. والشاشة التي لا يمكن التعبير عنها بنقطة وصول عامة هي شاشة لم تكتمل المنصة لأجلها بعد، والتشغيل في الظل هو حيث يُكتشف ذلك.",
  "The programme": "البرنامج",
  "screens served by the platform": "شاشات تقدّمها المنصة",
  "{pct}% of those declared": "{pct}% من المُعلَنة",
  "agreement while shadowing": "نسبة التطابق أثناء التشغيل في الظل",
  "{n} run(s) recorded": "عدد مرات التشغيل المسجّلة: {n}",
  "differences not yet triaged": "فروق لم تُفرز بعد",
  "each blocks a cutover": "كل منها يمنع الانتقال",
  "nothing waiting": "لا شيء بانتظار",
  "ready to cut over": "جاهزة للانتقال",
  "slowest shadow answer": "أبطأ إجابة في الظل",
  "95th percentile, what a user would feel": "المئين 95، ما سيشعر به المستخدم",
  "What the fraction means": "ماذا تعني النسبة",
  "the platform's own words, kept rather than paraphrased": "كلمات المنصة نفسها، محفوظة دون إعادة صياغة",
  "triage first, then cut over what has earned it, then feed the screens still short of runs":
    "الفرز أولًا، ثم نقل ما استحق الانتقال، ثم تغذية الشاشات التي تنقصها مرات التشغيل",
  "Every declared screen is live.": "كل الشاشات المُعلَنة قيد التشغيل الفعلي.",
  "The screens": "الشاشات",
  "what is declared, how it is going, and what the platform's guard says about each":
    "ما هو مُعلَن، وكيف يسير، وما يقوله حارس المنصة عن كل منها",
  Screen: "الشاشة",
  Mode: "الوضع",
  Progress: "التقدّم",
  Agreement: "التطابق",
  Runs: "مرات التشغيل",
  Blocking: "المانع",
  LIVE: "فعلي",
  SHADOW: "ظل",
  OFF: "متوقف",
  "{pct}% of the way to a cutover": "{pct}% من الطريق إلى الانتقال",
  "served by the platform since {date}": "تقدّمها المنصة منذ {date}",
  "served by the platform": "تقدّمها المنصة",
  "nothing — the guard would allow it": "لا شيء — سيسمح الحارس بذلك",
  "How the integration is installed": "كيف يُثبَّت التكامل",
  "one call, once — migrating the next screen needs no further change to the application being replaced":
    "استدعاء واحد، مرة واحدة — نقل الشاشة التالية لا يتطلب أي تغيير إضافي في التطبيق المستبدَل",
  "Compute the screen’s answer exactly as the existing application does today.":
    "احسب إجابة الشاشة تمامًا كما يفعل التطبيق القائم اليوم.",
  "Post it to the platform with the screen key and the request parameters.":
    "أرسلها إلى المنصة مع مفتاح الشاشة ومعاملات الطلب.",
  "Return what comes back, not your own rows, and render it exactly as before.":
    "أعِد ما يرجع إليك، لا صفوفك الخاصة، واعرضه تمامًا كما كان.",
  "Fail open. On any error, timeout or refusal, return your own answer — the shim must never be able to break a screen.":
    "عند الإخفاق تابِع العمل. عند أي خطأ أو انتهاء مهلة أو رفض، أعِد إجابتك الخاصة — يجب ألا تتمكن طبقة الوصل من تعطيل أي شاشة أبدًا.",
  "{label} — recorded": "{label} — سُجّل",
  "{mode} — overridden, and the override is recorded": "{mode} — تم التجاوز، وسُجّل التجاوز",
  "{name} — migration": "{name} — الترحيل",
  "The four conditions": "الشروط الأربعة",
  "The platform decides; these are the distances, which it does not report as numbers.":
    "المنصة هي التي تقرّر؛ وهذه هي المسافات المتبقية، التي لا تُبلغ عنها بالأرقام.",
  "not yet": "ليس بعد",
  "Evidence · {days} days, contract v{version}": "الأدلة · {days} يومًا، العقد v{version}",
  " · platform p95 {ms} ms": " · المنصة p95 {ms} ms",
  "Agreement counts only what the contract could compare, so a contract comparing nothing cannot report a hundred per cent. This screen needs {pct}%.":
    "لا يحتسب التطابق إلا ما استطاع العقد مقارنته، لذا فالعقد الذي لا يقارن شيئًا لا يمكنه الإبلاغ عن مئة بالمئة. تحتاج هذه الشاشة إلى {pct}%.",
  "Triaged: {list}": "المفروز: {list}",
  "Differences waiting · {n}": "الفروق المنتظرة · {n}",
  "Nothing waiting. Every difference recorded under this contract has been looked at.":
    "لا شيء بانتظار. رُوجع كل فرق سُجّل بموجب هذا العقد.",
  "The existing screen": "الشاشة القائمة",
  "This platform": "هذه المنصة",
  "Which side was wrong?": "أي الطرفين كان مخطئًا؟",
  "The platform never decides this. The existing screen is often the one that is wrong, and that is frequently why it is being replaced.":
    "المنصة لا تقرّر هذا أبدًا. كثيرًا ما تكون الشاشة القائمة هي المخطئة، وهذا غالبًا سبب استبدالها.",
  "The contract": "العقد",
  "A contract names a public endpoint and how to read it. It cannot carry a query: a screen that cannot be served by the public API is a screen the API is not finished for.":
    "يسمّي العقد نقطة وصول عامة وكيفية قراءتها. ولا يمكنه أن يحمل استعلامًا: فالشاشة التي لا تستطيع واجهة API العامة تقديمها شاشة لم تكتمل الواجهة لأجلها بعد.",
  "Move this screen": "نقل هذه الشاشة",
  "why — recorded with the change": "السبب — يُسجَّل مع التغيير",
  "Shadow run it": "تشغيلها في الظل",
  "Cut over to the platform": "الانتقال إلى المنصة",
  "Revert to the existing screen": "العودة إلى الشاشة القائمة",
  "Stop migrating it": "إيقاف ترحيلها",
  "This screen has not earned a cutover yet.": "لم تستحق هذه الشاشة الانتقال بعد.",
  "Override with this reason": "التجاوز بهذا السبب",
  "the override is recorded against your name": "يُسجَّل التجاوز باسمك",
  "an override needs a written reason": "التجاوز يحتاج إلى سبب مكتوب",
  "Reverting has no guard and never will. The property that makes a cutover safe to attempt is that undoing it is one call and needs no deploy.":
    "العودة لا يحرسها شيء ولن يحرسها. ما يجعل محاولة الانتقال آمنة هو أن التراجع عنه استدعاء واحد لا يحتاج إلى نشر.",
  "What has happened to it": "ما جرى لها",
  " (overridden)": " (تم التجاوز)",
  "Not being migrated": "لا يجري ترحيلها",
  "Shadow running": "تعمل في الظل",
  "Served by the platform": "تقدّمها المنصة",
  Agreed: "متطابقة",
  Differed: "مختلفة",
  "Different shape": "بنية مختلفة",
  "Not comparable": "غير قابلة للمقارنة",
  "Platform failed": "أخفقت المنصة",
  "The platform was wrong": "كانت المنصة مخطئة",
  "The existing screen was wrong": "كانت الشاشة القائمة مخطئة",
  "Both defensible": "كلاهما قابل للدفاع عنه",
  Noise: "تشويش",
  "{recorded} recorded, {comparable} comparable": "{recorded} مسجّلة، {comparable} قابلة للمقارنة",
  "{pct}% agreement or better": "تطابق {pct}% أو أفضل",
  "nothing comparable yet": "لا شيء قابل للمقارنة بعد",
  "every difference looked at": "مراجعة كل فرق",
  "{n} not yet triaged": "{n} لم تُفرز بعد",
  "all triaged": "فُرزت كلها",
  "a conformance run behind it": "تشغيل مطابقة يدعمها",
  "none on record": "لا شيء مسجّل",
  "on record": "مسجّل",
  "a cutover cannot be earned on differences nobody has looked at": "لا يُستحق الانتقال بفروق لم يراجعها أحد",
  "every condition is met and the guard would allow it": "كل الشروط مستوفاة وسيسمح الحارس بذلك",
  "Start shadow running": "بدء التشغيل في الظل",
  "Keep shadowing — {short}": "مواصلة التشغيل في الظل — {short}",
  "nothing is recorded while a screen is off": "لا يُسجَّل شيء ما دامت الشاشة متوقفة",
  "the evidence is not there yet": "الأدلة لم تكتمل بعد",
  "{name} — {runs} shadow run(s) over {days} days, contract v{version}":
    "{name} — مرات التشغيل في الظل: {runs} خلال {days} يومًا، العقد v{version}",
  "{n} shadow run|{n} shadow runs":
    "لا تشغيل في الظل|تشغيل واحد في الظل|تشغيلان في الظل|{n} مرات تشغيل في الظل|{n} مرة تشغيل في الظل|{n} مرة تشغيل في الظل",
  "Triage {n} difference|Triage {n} differences":
    "لا فروق للفرز|فرز فرق واحد|فرز فرقين|فرز {n} فروق|فرز {n} فرقًا|فرز {n} فرق",

  // the dynamic map
  "Loading the map…": "جارٍ تحميل الخريطة…",
  "{site} · airfield": "{site} · الجانب الجوي",
  "Time window": "النطاق الزمني",
  "Last 24 h": "آخر 24 ساعة",
  "Last 7 days": "آخر 7 أيام",
  Layers: "الطبقات",
  Drawing: "المخطط",
  "Not placeable": "تعذّر تحديد موقعها",
  "{n} item carry no position or a tag the drawing does not know; listed on the right.|{n} items carry no position or a tag the drawing does not know; listed on the right.":
    "لا عناصر بلا موقع.|عنصر واحد بلا موقع أو بوسم لا يعرفه المخطط؛ مدرج في القائمة الجانبية.|عنصران بلا موقع أو بوسم لا يعرفه المخطط؛ مدرجان في القائمة الجانبية.|{n} عناصر بلا موقع أو بوسم لا يعرفه المخطط؛ مدرجة في القائمة الجانبية.|{n} عنصرًا بلا موقع أو بوسم لا يعرفه المخطط؛ مدرجة في القائمة الجانبية.|{n} عنصر بلا موقع أو بوسم لا يعرفه المخطط؛ مدرجة في القائمة الجانبية.",
  "Loading the drawing…": "جارٍ تحميل المخطط…",
  "On the map": "على الخريطة",
  "{n} item in the window|{n} items in the window":
    "لا عناصر في النطاق|عنصر واحد في النطاق|عنصران في النطاق|{n} عناصر في النطاق|{n} عنصرًا في النطاق|{n} عنصر في النطاق",
  "Nothing open in this window at {site}.": "لا شيء مفتوح في هذا النطاق في {site}.",
  "no position, and no tag the drawing knows": "بلا موقع، ولا وسم يعرفه المخطط",
  "How the airfield is shown": "طريقة عرض الجانب الجوي",
  "Real day": "الواقع نهارًا",
  "Real night": "الواقع ليلًا",
  "INSPECT {runway}": "فحص {runway}",
  "Loading the teams…": "جارٍ تحميل الفرق…",
  "TEAM POSITIONS ARE SIMULATED UNTIL A VEHICLE FEED IS CONNECTED · REAL VIEWS ARE PAINTED FROM THE RECORDS; DERIVED ITEMS ARE MARKED ON THE INTERACTIVE MAP":
    "مواقع الفرق محاكاة إلى أن تُوصل تغذية المركبات · العروض الواقعية مرسومة من السجلات؛ والعناصر المشتقة مُعلَّمة على الخريطة التفاعلية",
  "Clear selection": "إلغاء التحديد",
  "Open work order →": "فتح أمر العمل ←",
  Alert: "تنبيه",
  Raised: "تاريخ الإطلاق",
  "Why did this fire? →": "لماذا انطلق هذا؟ ←",
  "Inspection failure": "إخفاق في الفحص",
  Round: "جولة التفتيش",
  Defect: "العيب",
  Photos: "الصور",
  "Open the round →": "فتح جولة التفتيش ←",
  "Zoom in": "تكبير",
  "Zoom out": "تصغير",
  "Fit to drawing": "ملاءمة المخطط",
  "Fit (or double-click the map)": "ملاءمة (أو انقر الخريطة نقرًا مزدوجًا)",
  "Inspection failures": "إخفاقات الفحص",

  // model drift
  "Do the models still describe the estate": "هل ما زالت النماذج تصف الأصول",
  Checks: "الفحوص",
  "What is due": "ما هو مستحق",
  "No drift check has been run against this site yet.": "لم يُجرَ أي فحص انحراف على هذا الموقع بعد.",
  "Due now — {n}": "مستحق الآن — {n}",
  "A model whose check is overdue is a model nobody is currently watching.":
    "النموذج المتأخر فحصه نموذج لا يراقبه أحد حاليًا.",
  "Every model has been checked within its cycle.": "فُحص كل نموذج ضمن دورته.",
  "Within cycle — {n}": "ضمن الدورة — {n}",
  "Checked recently enough that another check would measure the same outcomes twice.":
    "فُحص مؤخرًا بما يكفي لأن يقيس فحص آخر النتائج نفسها مرتين.",
  "Nothing is inside its cycle.": "لا شيء ضمن دورته.",
  Drifted: "انحرف",
  "Still describes the estate": "ما زال يصف الأصول",
  "Cannot say yet": "لا يمكن الحكم بعد",
  Decided: "المحسومة",
  "Horizon not elapsed": "لم ينقضِ الأفق",
  Judgeable: "قابلة للحكم",
  "Change point": "نقطة التغيّر",
  "Window {from} to {to}": "النافذة من {from} إلى {to}",
  " · checked {when}": " · فُحص {when}",
  Every: "كل",
  "Last checked": "آخر فحص",
  "{n} d": "{n} يوم",

  // reliability
  "How the fleet actually fails": "كيف تتعطل الأصول فعلًا",
  Populations: "المجموعات",
  "Units and failures. The gap between them is what a failures-only fit would throw away.":
    "الوحدات والأعطال. الفجوة بينهما هي ما سيُهمله توفيق يعتمد على الأعطال وحدها.",
  Population: "المجموعة",
  "Measured in": "وحدة القياس",
  Units: "الوحدات",
  Failures: "الأعطال",
  "Still running": "ما زالت تعمل",
  "No fit has been recorded for {population}.": "لم يُسجَّل أي توفيق للمجموعة {population}.",
  "Show the fit": "عرض التوفيق",
  "cannot be fitted": "لا يمكن توفيقها",
  "Wears out with age": "تبلى مع العمر",
  "Fails early or not at all": "تتعطل مبكرًا أو لا تتعطل أبدًا",
  "Constant failure rate": "معدل أعطال ثابت",
  "Shape not established": "الشكل غير مثبت",
  "{censored} of {units} units have not failed and are kept in the fit — {pct}% of the sample. Dropping them is the classic error, and it biases the estimated life downwards, never up.":
    "{censored} من {units} وحدة لم تتعطل وأُبقيت في التوفيق — {pct}% من العينة. إسقاطها هو الخطأ الشائع، وهو ينحاز بالعمر المقدَّر نحو الأسفل، لا الأعلى أبدًا.",
  "{censored} of {units} units have not failed and are kept in the fit. Dropping them is the classic error, and it biases the estimated life downwards, never up.":
    "{censored} من {units} وحدة لم تتعطل وأُبقيت في التوفيق. إسقاطها هو الخطأ الشائع، وهو ينحاز بالعمر المقدَّر نحو الأسفل، لا الأعلى أبدًا.",
  "Shape (beta)": "الشكل (beta)",
  "Characteristic life": "العمر المميِّز",
  "The latest observed failure was at {at} {unit}. The characteristic life above is beyond that point — a property of the model rather than something the fleet has demonstrated.":
    "كان آخر عطل مرصود عند {at} {unit}. العمر المميِّز أعلاه يتجاوز تلك النقطة — فهو خاصية للنموذج لا شيء أثبتته الأصول.",
  "The latest observed failure was at {at} {unit}. The characteristic life above is within it — inside the range the fleet has actually demonstrated.":
    "كان آخر عطل مرصود عند {at} {unit}. العمر المميِّز أعلاه ضمنها — داخل المدى الذي أثبتته الأصول فعلًا.",
  "Fitted {when} · {method}": "وُفّق {when} · {method}",

  // weather
  "Can the work happen": "هل يمكن تنفيذ العمل",
  "The question": "السؤال",
  "A limit that cannot be evaluated is reported as unknown, never as a pass.":
    "الحد الذي لا يمكن تقييمه يُبلَّغ عنه بأنه غير معروف، لا بأنه مُجتاز أبدًا.",
  "Work category": "فئة العمل",
  At: "في",
  "e.g. crack-seal": "مثال: crack-seal",
  "Name the work and the engine will say whether it can happen.": "سمِّ العمل وسيحدّد المحرك إن كان يمكن تنفيذه.",
  "Within limits": "ضمن الحدود",
  "Outside limits": "خارج الحدود",
  "Cannot be determined": "لا يمكن تحديده",
  "The work can go ahead": "يمكن المضي في العمل",
  "The work cannot go ahead": "لا يمكن المضي في العمل",
  "Not established — this is not permission": "غير مثبت — وهذا ليس إذنًا",
  "{made} of {n} limit on file could be evaluated.": "أمكن تقييم {made} من {n} من الحدود المسجّلة.",
  "{made} of {n} limits on file could be evaluated.": "أمكن تقييم {made} من {n} من الحدود المسجّلة.",
  " Conditions from {basis}.": " الظروف مأخوذة من {basis}.",
  "What was measured": "ما قيس",
  "The readings the verdict was built from.": "القراءات التي بُني عليها الحكم.",
  Air: "الهواء",
  Surface: "السطح",
  Wind: "الرياح",
  Gust: "الهبّات",
  Visibility: "مدى الرؤية",
  "Not all of these can be waited out — the kind says which.": "ليس كل هذه يزول بالانتظار — النوع يبيّن أيها.",
  " · waiting will not help": " · الانتظار لن يفيد",
  "Could not be evaluated": "تعذّر تقييمها",
  "These are readings nobody has taken. They are not passes, and the work is not cleared by their silence.":
    "هذه قراءات لم يأخذها أحد. ليست اجتيازًا، ولا يُجاز العمل بسكوتها.",
  "Material — the work would be ruined": "المواد — سيفسد العمل",
  "Personnel — the crew would be harmed": "الأفراد — سيتضرر الطاقم",
  "Regulatory — not negotiable": "تنظيمي — غير قابل للتفاوض",

  // the ledger of parties
  "Where the parties disagree": "حيث تختلف الأطراف",
  "Nothing has been asserted to the ledger for this site.": "لم يُسجَّل أي إفادة في السجل لهذا الموقع.",
  "Facts on the ledger": "الوقائع في السجل",
  "Only subjects both parties reported can diverge. The rest are one party talking.":
    "لا يمكن أن تختلف إلا الموضوعات التي أبلغ عنها الطرفان. والباقي طرف واحد يتحدث.",
  Fact: "الواقعة",
  Assertions: "الإفادات",
  Comparable: "القابلة للمقارنة",
  "Who settles it": "من يحسمها",
  "{comparable} of {subjects}": "{comparable} من {subjects}",
  "nobody has agreed": "لم يُتفق على أحد",
  "Compare parties": "مقارنة الأطراف",
  "{label} · {a} against {b}": "{label} · {a} مقابل {b}",
  "A process difference": "فرق في الإجراءات",
  "Measurement noise": "تشويش في القياس",
  "Nothing to compare": "لا شيء للمقارنة",
  "{minutes} minutes apart, median": "بفارق {minutes} دقيقة، بالوسيط",
  "Paired observations": "الملاحظات المقترنة",
  "Spread (IQR)": "التشتت (IQR)",
  "Points one way": "يتجه في اتجاه واحد",

  // deferred cost
  "What deferring maintenance costs": "كم يكلّف تأجيل الصيانة",
  "Budget curve": "منحنى الميزانية",
  Register: "السجل",
  "Fiscal year": "السنة المالية",
  "Each envelope is a budget you might be given. What changes is which candidates slip.":
    "كل سقف هو ميزانية قد تُمنح لك. وما يتغير هو أي البنود يتأجل.",
  "These totals are incomplete": "هذه المجاميع غير مكتملة",
  "{priced} of {candidates} candidates carry a cost.": "{priced} من {candidates} بندًا لها تكلفة.",
  "Every figure below is the sum of the {priced} that could be priced. The other {notPriced} are not zero — nobody has priced them.":
    "كل رقم أدناه هو مجموع البنود الـ{priced} التي أمكن تسعيرها. أما الـ{notPriced} الأخرى فليست صفرًا — لم يسعّرها أحد.",
  "No liability curve for this year — no candidates have been forecast yet.":
    "لا يوجد منحنى التزامات لهذه السنة — لم يُتنبأ بأي بنود بعد.",
  "Budget envelopes, {year}": "سقوف الميزانية، {year}",
  "Read it worst first: the tighter the budget, the more slips and the more waiting costs.":
    "اقرأه من الأسوأ: كلما ضاقت الميزانية زاد ما يتأجل وزادت تكلفة الانتظار.",
  "No envelopes are configured for this site.": "لم تُضبط أي سقوف لهذا الموقع.",
  "Excluded from every figure above": "مستبعد من كل الأرقام أعلاه",
  "Named rather than dropped: an excluded candidate is a gap in the number, not an absence of work.":
    "مسمّى لا مُسقَط: البند المستبعد فجوة في الرقم، لا غياب للعمل.",
  Candidate: "البند",
  "Why it carries no cost": "لماذا لا تكلفة له",
  "At {amount}": "عند {amount}",
  "Nothing slips": "لا شيء يتأجل",
  "Cost of waiting not computable": "تعذّر حساب تكلفة الانتظار",
  "This envelope funds every priced candidate.": "يموّل هذا السقف كل البنود المسعّرة.",
  "{n} slip, but their escalation could not be computed.": "يتأجل {n}، لكن تعذّر حساب تصاعد تكلفتها.",
  "is what waiting one year costs on the {n} candidate this envelope cannot fund.|is what waiting one year costs on the {n} candidates this envelope cannot fund.":
    "هي تكلفة انتظار سنة واحدة.|هي تكلفة انتظار سنة واحدة على البند الذي لا يستطيع هذا السقف تمويله.|هي تكلفة انتظار سنة واحدة على البندين اللذين لا يستطيع هذا السقف تمويلهما.|هي تكلفة انتظار سنة واحدة على {n} بنود لا يستطيع هذا السقف تمويلها.|هي تكلفة انتظار سنة واحدة على {n} بندًا لا يستطيع هذا السقف تمويلها.|هي تكلفة انتظار سنة واحدة على {n} بند لا يستطيع هذا السقف تمويلها.",
  Funded: "مموَّل",
  Deferred: "مؤجَّل",
  "{n} closure h/yr": "{n} ساعة إغلاق/سنة",
  "closure hours unknown": "ساعات الإغلاق غير معروفة",
  "The register": "السجل",
  "Every priced figure carries the rate, the date it was priced, the quantity and the deferral factor — so an input can be disputed instead of the conclusion dismissed.":
    "كل رقم مسعّر يحمل السعر وتاريخ تسعيره والكمية ومعامل التأجيل — ليمكن الاعتراض على مُدخل بدل رفض النتيجة.",
  Forecast: "التنبؤ",
  "Cost now": "التكلفة الآن",
  "If deferred": "في حال التأجيل",
  "not priced": "غير مسعّر",
  "{quantity} {unit} at {rate}, priced {date} ({source}). ":
    "{quantity} {unit} بسعر {rate}، سُعّر في {date} ({source}). ",
  "source not stated": "المصدر غير مذكور",
  /* the identity provider's door (PlatformGate) and what it refuses */
  "Sign in to the platform": "تسجيل الدخول إلى المنصة",
  "Use the account your administrator created for you.": "استخدم الحساب الذي أنشأه لك المسؤول.",
  "SIGNING IN…": "جارٍ تسجيل الدخول…",
  "FIRST TIME, OR FORGOTTEN THE PASSWORD?": "أول مرة، أو نسيت كلمة المرور؟",
  "Set a password": "تعيين كلمة مرور",
  "We will email you a link": "سنرسل إليك رابطًا بالبريد الإلكتروني",
  "Enter the address your account was created with. The link lets you choose a new password, or your first one.":
    "أدخل العنوان الذي أُنشئ به حسابك. يتيح لك الرابط اختيار كلمة مرور جديدة، أو كلمتك الأولى.",
  "SEND THE LINK": "إرسال الرابط",
  "BACK TO SIGN IN": "العودة إلى تسجيل الدخول",
  "Check your inbox": "تحقق من بريدك الوارد",
  "If that address has an account, the link is on its way": "إذا كان لهذا العنوان حساب، فالرابط في طريقه إليك",
  "It can take a minute, and may land in junk mail. This screen does not say whether the address has an account, so that nobody can use it to find out.":
    "قد يستغرق ذلك دقيقة، وقد يصل إلى البريد غير المرغوب فيه. لا تُبيّن هذه الشاشة ما إذا كان للعنوان حساب، حتى لا يستخدمها أحد لمعرفة ذلك.",
  "Signed in — no access yet": "تم تسجيل الدخول — لا صلاحية بعد",
  "The platform did not accept this sign-in": "لم تقبل المنصة تسجيل الدخول هذا",
  "You are signed in as {name}, but no role has been given to this account. An administrator assigns one under Administration › People; sign in again once they have.":
    "أنت مسجّل الدخول باسم {name}، لكن لم يُمنح هذا الحساب أي دور. يعيّن المسؤول دورًا من الإدارة › الأشخاص؛ سجّل الدخول مجددًا بعد أن يفعل.",
  "The sign-in worked, but the platform does not recognize it. This usually means the sign-in provider has not been registered with the platform yet. Tell your administrator.":
    "نجح تسجيل الدخول، لكن المنصة لا تتعرّف عليه. يعني هذا عادةً أن مزوّد تسجيل الدخول لم يُسجَّل لدى المنصة بعد. أبلغ المسؤول.",
  "That email and password do not match an account. First time here? Your account starts with no password — set one with the link below.":
    "لا يطابق هذا البريد الإلكتروني وكلمة المرور أي حساب. أول مرة هنا؟ يبدأ حسابك بلا كلمة مرور — عيّن واحدة من الرابط أدناه.",
  "This account has been disabled. Ask your administrator.": "هذا الحساب معطَّل. راجع المسؤول.",
  "Too many attempts. Wait a few minutes, or reset the password.":
    "محاولات كثيرة جدًا. انتظر بضع دقائق، أو أعد تعيين كلمة المرور.",
  "The sign-in service could not be reached. Check the connection and try again.":
    "تعذّر الوصول إلى خدمة تسجيل الدخول. تحقق من الاتصال وحاول مجددًا.",
  "This account asks for a second factor, which this screen cannot take yet. Ask your administrator.":
    "يطلب هذا الحساب عاملًا ثانيًا لا تستطيع هذه الشاشة استقباله بعد. راجع المسؤول.",
  /* Administration: invite by email, provider controls, setup actions */
  "How: ": "الطريقة: ",
  "{name} was already listed; {role} added, at {level}.": "{name} مدرج من قبل؛ أُضيف الدور {role}، بمستوى {level}.",
  "{name} invited as {role}, at {level}. The set-password email has gone to {email}.":
    "دُعي {name} بدور {role}، بمستوى {level}. أُرسل بريد تعيين كلمة المرور إلى {email}.",
  "{email} already had a sign-in account, so it was bound to {name} as {role}, at {level}. A set-password email has gone to them too.":
    "كان لـ {email} حساب تسجيل دخول من قبل، فرُبط بـ {name} بدور {role}، بمستوى {level}. وأُرسل إليه بريد تعيين كلمة المرور أيضًا.",
  role: "الدور",
  "choose a role": "اختر دورًا",
  "inviting…": "جارٍ الإرسال…",
  Invite: "دعوة",
  "Invite by email": "دعوة بالبريد الإلكتروني",
  "their sign-in account is made for them and the set-password link is emailed":
    "يُنشأ حساب تسجيل الدخول له ويُرسل رابط تعيين كلمة المرور بالبريد",
  "{name}: {n} signing keys fetched and cached.": "{name}: جُلب {n} من مفاتيح التوقيع وخُزّنت.",
  "Default role for {name}": "الدور الافتراضي لـ {name}",
  "{name}: somebody signing in with no role now gets {role}.": "{name}: من يسجّل الدخول بلا دور يحصل الآن على {role}.",
  "{name}: somebody signing in with no role now gets nothing until given one.":
    "{name}: من يسجّل الدخول بلا دور لا يحصل الآن على شيء حتى يُمنح دورًا.",
  "{name} switched off: its tokens are no longer accepted.": "أُوقف {name}: لم تعد رموزه مقبولة.",
  "{name} switched on.": "شُغّل {name}.",
  "Switch off": "إيقاف",
  "Switch on": "تشغيل",
  "Refresh keys": "تحديث المفاتيح",
  "The default role is what somebody gets when they sign in holding no role at all. Leave it empty and a person nobody has given a role sees nothing until an administrator does. Switching off the only provider people sign in with is refused, because it would lock everybody out.":
    "الدور الافتراضي هو ما يحصل عليه من يسجّل الدخول دون أي دور. اتركه فارغًا ولن يرى من لم يُمنح دورًا شيئًا حتى يمنحه المسؤول دورًا. ويُرفض إيقاف المزوّد الوحيد الذي يسجّل الناس الدخول به، لأنه سيغلق الباب على الجميع.",
  "Invite people": "دعوة الأشخاص",
  "Give everybody a role": "امنح الجميع دورًا",
  "Invite a second administrator": "ادعُ مسؤولًا ثانيًا",
  "Open sign-in": "فتح تسجيل الدخول",
  "Set role levels": "تعيين مستويات الأدوار",
  "Load the estate": "تحميل الأصول",
  "This is how the API is started, not a setting on this screen: set SLT_DEV_AUTH=0 on the API service and deploy it again.":
    "هذه طريقة تشغيل الواجهة البرمجية، لا إعداد في هذه الشاشة: اضبط SLT_DEV_AUTH=0 على خدمة الواجهة البرمجية وأعد نشرها.",
  "A pack is installed on the server with the pack installer; it cannot be installed from this screen.":
    "تُثبَّت الحزمة على الخادم بأداة تثبيت الحزم؛ ولا يمكن تثبيتها من هذه الشاشة.",
  "Machine access keys are issued on the server with issue_key; each one is listed with its scopes when it exists.":
    "تُصدر مفاتيح وصول الأنظمة على الخادم بالأداة issue_key؛ ويُدرج كل مفتاح بنطاقاته عند وجوده.",
  "The organisation's name is set when the tenant is provisioned on the server.":
    "يُحدَّد اسم المؤسسة عند تهيئة المستأجر على الخادم.",
  "{name} added as {role}, at {level}. No email was sent.":
    "أُضيف {name} بدور {role}، بمستوى {level}. لم يُرسل أي بريد.",
};
export default ar;
